const EXPORT_MUTATION_TYPES = Object.freeze({
  FETCH_EXPORT_EVENT_USERS: 'FETCH_EXPORT_EVENT_USERS',

  SET_ERROR: 'SET_ERROR',
  SET_BUTTON_LOADING_STATE: 'SET_BUTTON_LOADING_STATE',
});

export default EXPORT_MUTATION_TYPES;
